import { default as auth } from "./modules/auth";
import { default as buildings } from "./modules/buildings";
import { default as companies } from "./modules/companies";
import { default as realtors } from "./modules/realtors";
import { default as properties } from "./modules/properties";
import { default as leads } from "./modules/leads";
import { default as leadImports } from "./modules/lead_imports";
import { default as regions } from "./modules/regions";
import { default as states } from "./modules/states";
import { default as resources } from "./modules/resources";
import { default as users } from "./modules/users";
import { default as posts } from "./modules/blog";
import { default as teams } from "./modules/teams";
import { default as realEstate } from "./modules/real_estate";
import { default as challenges } from "./modules/challenges";
import { default as ranking } from "./modules/ranking";
import { default as content } from "./modules/content";
import { default as notification } from "./modules/notification";

export default {
  auth,
  buildings,
  companies,
  realtors,
  properties,
  leads,
  leadImports,
  regions,
  states,
  resources,
  users,
  posts,
  teams,
  realEstate,
  challenges,
  ranking,
  content,
  notification
};
